import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-policies',
    templateUrl: './policies.component.html',
    styleUrls: ['./policies.component.css'],
    standalone: false
})
export class PoliciesComponent implements OnInit {
  public version: string|null = environment.appVersion;

  constructor(private meta: Meta) { 
    this.meta.addTags([
      {name: 'description', content: 'Ddolphin Policies'},
      {name: 'author', content: 'Ddolphin'},
      {name: 'keywords', content: 'Education, Ddolphin, Learn, Teach, Social'}
    ]);
  }

  ngOnInit(): void {
  }

}
